import {EffectCallback, useEffect} from 'react';

/**
 * Custom React hook to call a function on mount - similar to componentDidMount in a class
 *
 * @example
 *    // Simple callback
 *    useOnMount(() => {
 *      setFoo(myInitialValue);
 *    });
 *
 *    // Callback returning cleanup function
 *    useOnMount((): (() => void) => {
 *      const abortController = new AbortController();
 *      fetch('https://example.com/', {signal: abortController.signal}).then((response) => {
 *        // do something with the response
 *      }).catch((reason: unknown) => {
 *        // ...
 *      })
 *
 *     return function cleanup() {
 *       abortController.abort();
 *     };
 *    }
 */
export default function useOnMount(makeCall: EffectCallback): void {
  // Adapted from https://reactjs.org/docs/hooks-effect.html#tip-optimizing-performance-by-skipping-effects
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(makeCall, []);
}
